import React from 'react'

import clsx from 'clsx'

import Stars from 'components/Stars'
import Typography from 'components/Typography'
import { formatRatingAverage } from 'helpers/formatters'

import classes from './Base.module.scss'

const ICONS_SIZES = {
  small: '16',
  medium: '16',
  large: '24',
}

const TYPOGRAPHY_SIZES = {
  small: 'tight-xxs',
  medium: 'tight-xs',
  large: 'body-sm',
}
/** @type {import("./types").default} */
const Base = ({ average = 0, className, hideAverage, isCompact, size = 'small', RatingStarsProps = {} }) => (
  <div className={clsx(classes.root, classes[size], className, { [classes.compact]: isCompact })}>
    {!hideAverage && (
      <Typography
        className={clsx(classes.average, 'RatingBase-average')}
        component="span"
        variant={TYPOGRAPHY_SIZES[size]}
      >
        {formatRatingAverage(average)}
      </Typography>
    )}
    <Stars
      className={classes.iconRating}
      rating={average}
      isCompact={isCompact}
      size={ICONS_SIZES[size]}
      {...RatingStarsProps}
    />
  </div>
)

export default Base
